import React from 'react';
export const SubscriptionContext = React.createContext({
  open() {
    console.error("SubscriptionOnly must be a parent component but it wasn't found");
  },
  close() {
    console.error("SubscriptionOnly must be a parent component but it wasn't found");
  },
});
